module.exports = __webpack_public_path__ + "img/naotu_1.37531773.png";